function ProductForm($form) {
	if (!$form) {
		console.warn("Form selector produced no element");
		return;
	}
	let product;

	function initializeData() {
		const productHandle = $form.dataset.productHandle;
		return fetch(`/products/${productHandle}.js`).then(res => res.json());
	}

	// Get the current option selections inside the form.
	function currentFormOptionSelections() {
		return ["option1", "option2", "option3"].map(optionName => {
			// Select either a checked input or <select> w/ the matching option names.
			let $input = $form.querySelector(
				`input[name="${optionName}"]:checked,select[name="${optionName}"]`
			);

			return {
				name: optionName,
				value: $input?.value || null,
			};
		});
	}

	// using option selections + product data. find variant.
	function currentVariant() {
		const currentOptions = currentFormOptionSelections();
		return product.variants.find(variant => {
			return currentOptions.every(
				({ name, value }) => variant[name] === value
			);
		});
	}

	// update variant input in form
	function updateVariantInput(variant) {
		$form.querySelector('input[name="id"]').value = variant ? variant.id : "";
	}

	function updateVariantImage(variant, blockId, variantIndex) {
		// Check if the variant object is defined
		if (!variant) {
			console.error("No variant found for the current option selections.");
			return;
		}
		// Construct the selector string using the block ID and variant index
		let selectorString = `.product-image-${blockId}-${variantIndex}`,
			// Select the image element using the constructed selector
			imageElement = document.querySelector(selectorString);

		// Update the image source and srcset
		if (imageElement) {
			imageElement.src = variant.featured_image.src;
			imageElement.alt = variant.featured_image.alt;

			let newSrcSetValues = `${imageElement.src}   200w, ${imageElement.src}   300w, ${imageElement.src}   400w, ${imageElement.src}   600w,${imageElement.src}   700w, ${imageElement.src}   800w, ${imageElement.src}   1000w, ${imageElement.src}   1200w, ${imageElement.src}   1400w, ${imageElement.src}   1600w,${imageElement.src}   1800w,${imageElement.src}   2000w,${imageElement.src}   2200w,`;

			// Update the srcset attribute
			imageElement.setAttribute("srcset", newSrcSetValues);
		}
	}

	function handleFormInput(event) {
		const selectedVariant = currentVariant();
		const blockId = event.target.closest(".custom-product-form").dataset
			.blockId;
		const variantIndex = event.target.closest(".custom-product-form").dataset
			.variantIndex;

		updateVariantInput(selectedVariant);
		updateVariantImage(selectedVariant, blockId, variantIndex);

		// console.log("selectedVariant", selectedVariant);

		const productCard = event.target.closest(".custom-product-card");
		if (productCard) {
			const variantTitleElement = productCard.querySelector(
				".selected-variant-title"
			);

			if (variantTitleElement && selectedVariant) {
				variantTitleElement.textContent = selectedVariant.option1;
			}

			const quickViewSubmitBtn = document.querySelector(
				'.quickshop-body button[type="submit"'
			);

			const mobileATC = productCard.querySelector(
					".custom-product-card .mobile-atc"
				),
				quickView = productCard.querySelector(
					".custom-product-card .quick-add-btn"
				);

			function updateButtonBasedOnInventory(button, selectedVariant) {
				if (!button) return;
				if (
					selectedVariant == undefined ||
					selectedVariant.inventory_quantity < 1
				) {
					button.textContent = "sold out";
					if (button.classList.contains("button-orange")) {
						button.classList.remove("button-orange");
						button.classList.add("button-orange-alt");
						button.disabled = true;
					}
				} else {
					button.textContent = "Add to Bag";

					if (button.classList.contains("button-orange-alt")) {
						button.classList.remove("button-orange-alt");
						button.classList.add("button-orange");
					}
				}
			}
			updateButtonBasedOnInventory(quickViewSubmitBtn, selectedVariant);
			updateButtonBasedOnInventory(mobileATC, selectedVariant);
			updateButtonBasedOnInventory(quickView, selectedVariant);
		}
	}

	function updateVariantTitle(title) {
		const productCard = $form.closest(".custom-product-card");
		if (productCard) {
			const variantTitleElement = productCard.querySelector(
				".selected-variant-title"
			);
			if (variantTitleElement) {
				variantTitleElement.textContent = title;
			}
		}
	}

	function handleLabelClick(event) {
		const inputId = event.target.getAttribute("for");
		const input = document.getElementById(inputId);

		setTimeout(() => {
			const selectedVariant = currentVariant();
			// Check if the inputId contains the word "size"
			if (inputId && inputId.includes("size")) {
				if (!selectedVariant && input) {
					input.classList.add("disabled");
				} else if (input) {
					input.classList.remove("disabled");
				}
			}
			// console.log("Sibling input:", input);
			// console.log("Selected variant:", selectedVariant);
		}, 0);
	}

	// component initializing function
	async function initialize() {
		product = await initializeData(); // need data ASAP

		const defaultVariant = product.variants[0];
		if (defaultVariant) {
			updateVariantTitle(defaultVariant.option1);
		}

		$form.addEventListener("input", handleFormInput); // This is a catch all, instead of assigning individual 'change' listeners.

		// Add event listener for label clicks
		const labels = $form.querySelectorAll("label[for]");
		labels.forEach(label => {
			label.addEventListener("click", handleLabelClick);
		});
	}
	// initialize
	initialize();
}

document.querySelectorAll("form.custom-product-form").forEach(formElement => {
	const productHandle =
		formElement.getAttribute("data-block-id") ??
		formElement.getAttribute("data-quickview-id");
	const $forms = document.querySelectorAll(
		`.custom-product-form[data-block-id="${productHandle}"]`
	);

	$forms.forEach($form => ProductForm($form));
});

// Redirect to href,we need to do this because <a> is in a form element
//  and without it it wouldn't work
let customProductCardA = document.querySelectorAll(".custom-product-card a");
let customProductCardLabels = document.querySelectorAll(
	".custom-product-card fieldset label"
);

customProductCardA.forEach(link => {
	link.addEventListener("click", function (event) {
		event.preventDefault();
		window.location.href = this.href;
	});
});

document.addEventListener("DOMContentLoaded", function () {
	// Select all product cards
	let productCards = document.querySelectorAll(".custom-product-card");

	productCards.forEach(productCard => {
		let quickAddBtn = productCard.querySelector(".quick-add-btn");
		let popupVariantContainer = productCard.querySelector(
			".popup-variant-container"
		);
		if (!popupVariantContainer) return;

		const showPopupVariantContainer = () => {
			popupVariantContainer.style.display = "flex";
			quickAddBtn.classList.add("fade-out");
		};

		const hidePopupVariantContainer = () => {
			popupVariantContainer.style.display = "none";
			quickAddBtn.classList.remove("fade-out");
		};

		quickAddBtn.addEventListener("mouseover", showPopupVariantContainer);

		quickAddBtn.addEventListener("mouseout", hidePopupVariantContainer);

		popupVariantContainer.addEventListener(
			"mouseover",
			showPopupVariantContainer
		);

		popupVariantContainer.addEventListener(
			"mouseout",
			hidePopupVariantContainer
		);

		const productForm = productCard.querySelector(".custom-product-form");
		if (!productForm) return;

		const productId = productForm.getAttribute("data-product-id");

		if (
			popupVariantContainer.querySelectorAll('input[type="radio"]').length >
			1
		) {
			const popupVariantInputs = popupVariantContainer.querySelectorAll(
				'input[type="radio"]'
			);

			popupVariantInputs.forEach(input => {
				input.addEventListener("change", function () {
					const ajaxAddToCartBtn = document.querySelector(
						`.quick-add-btn[data-product-id="${productId}"]`
					);

					if (ajaxAddToCartBtn) {
						ajaxAddToCartBtn.click();
					}
				});
			});
		}
	});
});
